module.exports = __webpack_public_path__ + "static/media/brands_WILO.d285e2cb.svg";